export default "__VITE_ASSET__CNrIHyw1__"